var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeleteButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "#DE4242"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.251 8.90546H17.758V9.32729H18.6633V8.84641C18.6634 8.37971 18.284 8 17.8175 8H15.1915C14.7251 8 14.3456 8.37971 14.3456 8.84641V9.32729H15.251V8.90546Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7539 12.9141H12.2546C12.0217 12.9141 11.8384 13.1127 11.8572 13.3449L12.5677 22.1312C12.6073 22.6217 13.0164 22.9995 13.508 22.9995H19.5004C19.992 22.9995 20.4011 22.6217 20.4407 22.1311L21.1512 13.3449C21.1701 13.1127 20.9868 12.9141 20.7539 12.9141ZM14.3126 22.0624C14.3031 22.0629 14.2936 22.0633 14.2842 22.0633C14.0469 22.0633 13.8476 21.8784 13.8329 21.6384L13.3876 14.4253C13.3722 14.1757 13.5621 13.9609 13.8116 13.9455C14.0603 13.9304 14.276 14.1198 14.2913 14.3695L14.7365 21.5826C14.7519 21.8322 14.5621 22.0469 14.3126 22.0624ZM16.962 21.6105C16.962 21.8605 16.7593 22.0632 16.5093 22.0632C16.2592 22.0632 16.0566 21.8605 16.0566 21.6105V14.3973C16.0566 14.1473 16.2592 13.9446 16.5093 13.9446C16.7592 13.9446 16.962 14.1473 16.962 14.3973V21.6105ZM19.6209 14.424L19.1958 21.6371C19.1817 21.8776 18.9821 22.0632 18.7443 22.0632C18.7354 22.0632 18.7264 22.0629 18.7173 22.0625C18.4677 22.0477 18.2773 21.8335 18.2921 21.5839L18.7171 14.3707C18.7317 14.1211 18.9453 13.9306 19.1956 13.9454C19.4452 13.9601 19.6356 14.1744 19.6209 14.424Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3198 11.5171L22.0224 10.6259C21.9441 10.3909 21.7241 10.2324 21.4763 10.2324H11.5327C11.285 10.2324 11.065 10.3909 10.9867 10.6259L10.6894 11.5171C10.632 11.689 10.7066 11.8643 10.8459 11.9518C10.9027 11.9874 10.9699 12.0088 11.0437 12.0088H21.9655C22.0393 12.0088 22.1066 11.9874 22.1632 11.9517C22.3025 11.8642 22.3771 11.6889 22.3198 11.5171Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteButton);
export default __webpack_public_path__ + "static/media/icon-delete-button.fce65b57bb10003a3e546285cff5c1a2.svg";
export { ForwardRef as ReactComponent };